module.exports = __webpack_public_path__ + "static/img/ok2.73fc98b.png";